<template>
  <DialogFormWrapper :hide-actions="!field.editable">
    <template #form>
      <v-form id="updateDialogForm" ref="updateOrderForm" class="custom-form pt-8" @submit.prevent="updateValue()">
        <v-row>
          <v-col cols="12">
            <component
              :is="component(field.type)"
              :field="field"
              :data="dialog.item"
              :root-data="dialog.rootData"
              @update="setUpdatedParams"
            />
          </v-col>
        </v-row>
      </v-form>
    </template>
    <template #submit v-if="field.editable">
      <v-btn
        color="primary"
        class="base-hover"
        :loading="isProcessing"
        :disabled="!editingItemId || !hasAnyParam"
        type="submit"
        form="updateDialogForm"
      >
        Zapisz zmianę
      </v-btn>
    </template>
  </DialogFormWrapper>
</template>

<script>
import rules from '../../utils/validators'
import DialogFormWrapper from './Partials/DialogFormWrapper'
import dynamicComponentMixin from '../../mixins/DynamicComponentMixin'
import { mapState, mapActions } from 'vuex'
import get from 'lodash/get'

export default {
  components: {
    DialogFormWrapper
  },
  mixins: [dynamicComponentMixin],
  data() {
    return {
      rules,
      params: {}
    }
  },
  computed: {
    ...mapState({
      dialog: state => state.layout.dialog.data,
      field: state => state.layout.dialog.data.field,
      isProcessing(state) {
        return state[this.dialog.tableName].isProcessing
      },
      currentUserId(state) {
        const module = this.$isLogisticsApp ? 'auth' : 'authClient'
        return state[module].user?.id
      }
    }),
    editingItemId() {
      const { item, idPath } = this.dialog
      const { fieldIdPath } = this.field // we allow override idPath in case of diffrent endpoint needed in field
      return get(item, fieldIdPath || idPath)
    },
    hasAnyParam() {
      return !!Object.keys(this.params).length
    },
    isEditingOwnPermissions() {
      return this.field.type === 'selectUserPermissions' && Number(this.editingItemId) === Number(this.currentUserId)
    }
  },
  methods: {
    ...mapActions({
      closeDialog: 'layout/closeDialog',
      editItem(dispatch, payload) {
        const tableName = this.field?.fieldEndpoint || this.dialog.tableName
        return dispatch(`${tableName}/editItem`, payload)
      },
      getItems(dispatch, tableName) {
        return dispatch(`${tableName}/getItems`)
      },
      logout(dispatch, { noApi } = {}) {
        const module = this.$isLogisticsApp ? 'auth' : 'authClient'
        return dispatch(`${module}/logout`, { noApi })
      }
    }),
    setUpdatedParams(params) {
      this.params = params
    },
    updateValue() {
      if (this.$refs.updateOrderForm.validate()) {
        const { endpoint, notWebSocketHandled } = this.dialog
        const { fieldEndpoint } = this.field
        const shouldLogout = this.isEditingOwnPermissions
        this.editItem({
          tableName: fieldEndpoint || endpoint, // we allow override endpoint in case of diffrent endpoint needed in field
          params: this.params,
          notWebSocketHandled,
          id: this.editingItemId
        }).then(() => {
          // Own permissions are cached in the session, so a fresh login is required.
          if (shouldLogout) this.logout({ noApi: true })
          const { refreshTables } = this.field
          if (refreshTables) refreshTables.forEach(table => this.getItems(table))
          this.closeDialog()
        })
      }
    }
  }
}
</script>
